import EditInfoModal from './EditInfoModal';
export default EditInfoModal;
